/** sdgs.un.org serves the official UN languages only; others fall back to English. */
const sdgSupportedLocales = new Set(['es', 'fr', 'ar', 'zh', 'ru']);
const sdgLocaleFallback: Record<string, string> = { ca: 'es', gl: 'es', eu: 'es' };

export function sdgGoalUrl(goal: number, locale: string): string {
	const resolvedLocale = sdgLocaleFallback[locale] ?? locale;
	const localePrefix = sdgSupportedLocales.has(resolvedLocale) ? `${resolvedLocale}/` : '';
	return `https://sdgs.un.org/${localePrefix}goals/goal${goal}`;
}
